module.exports = __webpack_public_path__ + "img/box.7c53e08f.png";